// extracted by mini-css-extract-plugin
export default {"innerWrapper":"kr-z","tooltipWrapper":"lr-z","icon":"mr-z","tooltip":"nr-z","content":"or-z"};